import config from '@/config'
import { ajax } from 'gkSrc/utils/request'
import moment from 'moment'

export default {
  /**
   * 获取官网文章数量
   * @see https://yapi.geekbang.org/project/116/interface/api/22817
   * @fires public/v1/misc/get_geekbang_count:getGeekbangCount
   */
   getGeekbangCount () {
    /**
     * return
     * @returns {Object}                          res
     * @returns {string}                          res.data 1--置顶文章数量 0--普通文章数量
     */
    return ajax({
      host: config.infoQHost,
      url: 'public/v1/misc/get_geekbang_count'
    })
  },
  /**
   * 官网文章列表
   * @see https://yapi.geekbang.org/project/116/interface/api/22818
   * @fires public/v1/misc/get_geekbang_list:getGeekbangList
   * @param {Number}  data.type      1置顶 0普通
   * @param {Number}  data.offset    page-1
   * @param {Number}  data.size      每页条数
   */
   getGeekbangList (data) {
    /**
     * return
     * @returns {Object}                          res.list
     * @returns {string}                          res.list.publish_time            发布时间
     * @returns {string}                          res.list.article_title           文章标题
     * @returns {string}                          res.list.article_summary         文章简介
     * @returns {string}                          res.list.article_cover           文章封面
     * @returns {string}                          res.list.article_cover_point     文章封面坐标
     * @returns {Array}                           res.list.author                  作者
     * @returns {Array}                           res.list.translator              译者
     * @returns {Array}                           res.list.planner                 策划
     */
    return ajax({
      data: data,
      host: config.infoQHost,
      url: 'public/v1/misc/get_geekbang_list'
    }).then(res => {
      res.list.map(item => {
        item.time = moment(item.publish_time).format('YYYY-MM-DD')
      })
       // 是否还有更多
      res.hasMore = res.count > ((data.offset + 1) * data.size)
      console.log(res, '9999')
      return res
    })
  }
}
